import { ASK_AIRA_CHAT_FEEDBACK } from './constants';

export const sendFeedbackApi = (request, getAPICallObject) => (payload, messageId) => {
    const url = `${ASK_AIRA_CHAT_FEEDBACK}/${messageId}`;
    return request(url, getAPICallObject('POST', payload));
};